module.exports = __webpack_public_path__ + "static/img/banner.4590f812.png";